import { Suspense } from 'react'
import { pageRegistry } from 'virtual:zing-registry'

export const Page = (path: string): JSX.Element => {
  const Component = pageRegistry[path]
  if (!Component) return <div />
  return <Suspense fallback={<div />}><Component /></Suspense>
}

export default Page
